import * as API from "../../utils/api";
import { makeApiCall } from "../../utils/customUtils";
import { CommonConstant } from '../../constants/common.constant';
export function GetPatientInsuranceInformation(data = {}) {
  return async (dispatch) => {
    const { orderId, doctorId, productId } = data;
    const url = `${CommonConstant.SCRIPTINGAGTR_URL}DoseSpot/GetAndSavePatientInsuranceInformation/${orderId}/${doctorId}/${productId}`;
    const api = API.get(url, {}, dispatch, undefined, false, true);
    const response = await makeApiCall(dispatch, api, '', '');
    return { data: response?.data || response || {} };
  };
}

export function GetPatientInsuranceEligibility(data = {}) {
  return async (dispatch) => {
    const url = `${CommonConstant.SCRIPTINGAGTR_URL}DoseSpot/GetAndSavePatientInsuranceEligibility`;
    const api = API.post(url, { data }, dispatch, undefined, false, true);
    return await makeApiCall(dispatch, api, '', '');
  };
}

export function GetPayerFormulary(data = {}) {
  return async (dispatch) => {
    const url = `${CommonConstant.SCRIPTINGAGTR_URL}DoseSpot/Formulary/GetPayerFormulary_Eligibilities`;
    const api = API.post(url, { data }, dispatch, undefined, false, true);
    return await makeApiCall(dispatch, api, '', '');
  };
}
export function SaveSelectedPatientEligibilityIdForRx(data = {}) {
  return async (dispatch) => {
    const url = `${CommonConstant.SCRIPTINGAGTR_URL}DoseSpot/SaveSelectedHcpPatientPatientEligibilityIdForRx`;
    const api = API.post(url, { data }, dispatch, undefined, false, true);
    return await makeApiCall(dispatch, api, '', '');
  };
}
export function GetProductsOther() {
  return async (dispatch) => {
    const url = `${CommonConstant.SCRIPTINGAGTR_URL}DoseSpot/GetProductsOther`;
    const api = API.get(url, {}, dispatch, undefined, false, true);
    const response = await makeApiCall(dispatch, api, '', '');
    return { data: response?.data || response || {} };
  };
}

export function GetPharmaciesOther() {
  return async (dispatch) => {
    const url = `${CommonConstant.SCRIPTINGAGTR_URL}DoseSpot/GetPharmaciesOther`;
    const api = API.get(url, {}, dispatch, undefined, false, true);
    const response = await makeApiCall(dispatch, api, '', '');
    return { data: response?.data || response || {} };
  };
}